import { Collection } from "@type-r/models";
import { asTimelessDate, Column, Columns, Flex } from "lqx-react";
import React from "react";
import { UnappliedCashChange } from "../../api/unappliedCash";
import { AssetTileField, AssetTileHeaderField, AssetTileStatusField, CheckboxColumn, EventsColumn, FirstColumn, SecondColumn, TileContainer, useAssetTileClasses } from "../../components/asset-section-styles";
import { DigiCheckbox, DigiTooltip, limitText } from "../../shared";
import { InblockedAssetsEventStatus } from "../inblocked-assets-event-status";
import { UnappliedCashExternalSystems } from "./externalSystems";

export const UnappliedCashTile = ($active, selected: Collection<UnappliedCashChange>, selectAllAssets) => (({ data, index, style }) => {
    const unappliedCashChange: UnappliedCashChange = data.items[index];
    const classes = useAssetTileClasses({ isSelected: $active.value && $active.value.id === unappliedCashChange.id });
    const $checked = selected ? selected.$includes(unappliedCashChange) : null;
    const applyNumbersFormat = (num) => parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    const onUnappliedCashClicked = unappliedCashChange => $active.set(unappliedCashChange);

    return (<>
        <div key={unappliedCashChange.id} style={style} className={classes.root} onClick={() => onUnappliedCashClicked(unappliedCashChange)}>
            <TileContainer>
                {selectAllAssets.value &&
                    <CheckboxColumn>
                        <DigiCheckbox checked={true} disabled={true} />
                    </CheckboxColumn>
                }
                {$checked && !selectAllAssets.value &&
                    <CheckboxColumn>
                        <DigiCheckbox $checked={$checked} disabled={selectAllAssets.value} />
                    </CheckboxColumn>
                }
                <Column>
                    <Flex row>
                        <Columns>
                            <EventsColumn>
                                <Flex row>
                                    <InblockedAssetsEventStatus assetChange={unappliedCashChange} externalSystems={UnappliedCashExternalSystems} />
                                </Flex>
                                <Flex row>
                                    {/* <>DummyCell</> */}
                                </Flex>
                            </EventsColumn>
                            <FirstColumn>
                                <Flex row>
                                    <DigiTooltip title={unappliedCashChange.referenceNumber}>
                                        <AssetTileStatusField> {limitText(unappliedCashChange.referenceNumber, 20)}</AssetTileStatusField>
                                    </DigiTooltip>
                                </Flex>
                                <Flex row>
                                    <AssetTileField>Effective Date {asTimelessDate(unappliedCashChange.effectiveDate)}</AssetTileField>
                                </Flex>
                            </FirstColumn>
                            <SecondColumn>
                                <Flex row>
                                    <DigiTooltip title={`${unappliedCashChange.payee.company.name} - ${unappliedCashChange.payor.company.name}`}>
                                        <AssetTileHeaderField >{limitText(unappliedCashChange.payee.company.name, 60)} {unappliedCashChange.payee.company.name && '-'} {limitText(unappliedCashChange.payor.company.name, 60)}</AssetTileHeaderField>
                                    </DigiTooltip>
                                </Flex>
                                <Flex row>
                                    <AssetTileField>Amount {applyNumbersFormat(unappliedCashChange.amount)} </AssetTileField>
                                </Flex>
                            </SecondColumn>
                        </Columns>
                    </Flex>
                </Column>
            </TileContainer>
        </div >
    </>
    )
})
